import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { toBase64 } from "../../utils/utils";

export const handleGeminiRequest = async (
  data,
  project_id,
  user_sub,
  file_id,
  fileType = null, 
  id_token
) => {
  const api = new ApiManager();

  let base64Data = null;
  let mimeType = null;
  let isUrl = typeof data === "string"; // Check if data is a URL

  try {
    if (!isUrl) {
      // Use the explicitly passed fileType if available, otherwise use data.type
      mimeType = fileType || data.type;

      // Convert file to Base64 if it's not a URL
      const fileBase64 = await toBase64(data);
      base64Data = fileBase64.split(",")[1]; // Remove "data:<mime>;base64,"
    } else {
      // Ensure URL has a proper schema (http/https)
      if (!data.startsWith("http://") && !data.startsWith("https://")) {
        data = `https://${data}`;
      }
    }

    const payload = {
      contents: [
        {
          parts: [
            {
              text: `Restituisci esclusivamente un JSON con quattro campi: 
                    - "tags": un array di 10 tag pertinenti al documento.
                    - "abstract": un riassunto del documento in italiano, scritto in stile accademico, formale e coerente, che evidenzi i concetti principali con chiarezza.
                    - "tldr": un riassunto ancora più breve del documento in italiano, sempre in stile accademico e formale, che sintetizzi il nucleo essenziale del contenuto.
                    - "title": un titolo esplicativo del documento in italiano, chiaro e coerente con il contenuto.

                    Non aggiungere testo extra, restituisci solo il JSON valido. 
                    ${isUrl ? `Il documento è disponibile all'URL: ${data}` : ""}`,
            },
          ],
        },
      ],
    };

    if (!isUrl) {
      payload.contents[0].parts.push({
        inline_data: {
          mime_type: mimeType, // Use the correctly determined MIME type
          data: base64Data, // Base64 encoded content
        },
      });
    }

    const response = await api.post(
      "",
      payload,
      {},
      "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=AIzaSyDvClphAGAXcJG-dSVotSMU5RlSvetRitQ"
    );

    const rawText = response.data.candidates[0]?.content?.parts[0]?.text || "";
    const cleanJsonString = rawText.replace(/```json\n?|\n?```/g, "");

    try {
      const jsonResponse = JSON.parse(cleanJsonString);
      console.log("✅ JSON Estratto:", jsonResponse);

      // Determine the correct key based on the file type
      let fileTypeKey;
      if (isUrl) {
        fileTypeKey = "url_key";
      } else if (mimeType === "application/pdf") {
        fileTypeKey = "document_key";
      } else if (mimeType === "image/png" || mimeType === "image/jpeg") {
        fileTypeKey = "image_key";
      } else {
        // Default fallback
        fileTypeKey = "document_key";
      }

      const payload = {
        project_id: project_id,
        [fileTypeKey]: file_id,
        tags: [...jsonResponse.tags],
        title: String(jsonResponse.title),
        abstract: String(jsonResponse.abstract),
        tldr: String(jsonResponse.tldr),
      };

      console.log("Payload finale:", JSON.stringify(payload, null, 2));
      console.log("ID Token:", id_token);

      // Determine the correct endpoint based on the file type
      let endpoint;
      if (isUrl) {
        endpoint = "/url/puttags";
      } else if (mimeType === "application/pdf") {
        endpoint = "/documents/puttags";
      } else if (mimeType === "image/png" || mimeType === "image/jpeg") {
        endpoint = "/images/puttags";
      } else {
        // Default fallback
        endpoint = "/documents/puttags";
      }

      api
        .put(endpoint, JSON.stringify(payload, null, 2), {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${id_token}`,
          },
        })
        .then((response) => console.log("✅ Risposta PUTTAGS:", response.data))
        .catch((error) => {
          if (error.response) {
            console.error("❌ Errore PUT:", {
              status: error.response.status,
              data: error.response.data,
              headers: error.response.headers,
            });
          } else {
            console.error("❌ Errore PUT generico:", error);
          }
        });
    } catch (error) {
      console.error("❌ Errore nel parsing JSON:", error);
    }
  } catch (error) {
    console.error(
      "Error calling Gemini AI:",
      error.response ? error.response.data : error
    );
  }
};

